import PropTypes from 'prop-types';

NumberSliderInput.propTypes = {
  labelText: PropTypes.string.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  value: PropTypes.any,
  fieldName: PropTypes.string.isRequired,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  suffix: PropTypes.string,
  prefix: PropTypes.string,
  showValueSuffix: PropTypes.bool,
  className: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default function NumberSliderInput({
  labelText,
  minValue,
  maxValue,
  value,
  fieldName,
  step = 1,
  onChange,
  suffix = '',
  prefix = '',
  showValueSuffix = true,
  description,
  className = '',
  inputClassName = '',
  disabled = false,
}) {
  function handleRangeChange(e) {
    const fakeEvent = {
      target: {
        name: e.target.name,
        value: e.target.valueAsNumber,
        valueAsNumber: e.target.valueAsNumber,
      },
    };
    onChange(fakeEvent);
  }
  return (
    <fieldset className={`fieldset ${className} pl-1`}>
      <legend className="fieldset-legend">{labelText}</legend>
      <label className="flex items-center">
        <input
          disabled={disabled}
          onChange={handleRangeChange}
          type="range"
          min={minValue}
          max={maxValue}
          step={step}
          name={fieldName}
          value={value}
          className={`range ${disabled ? 'disabled opacity-50' : 'range-secondary'} ${inputClassName} w-full`}
        />
        <span
          className={`min-w-5 ml-5 text-sm ${showValueSuffix ? 'block' : 'hidden'} ${disabled && 'opacity-50'}`}
        >
          {prefix}
          {value}
          {suffix}
        </span>
      </label>
      {description && (
        <div className="label">
          <span className="label-text-alt">{description}</span>
        </div>
      )}
    </fieldset>
  );
}
